import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { NavigationMenuElementComponent } from './navigation-menu-element';
import { NavigationMenuContainerInterface } from './navigation-menu-container.interface';

@Component({
    selector: 'qms-navigation-menu',
    templateUrl: './navigation-menu.component.html',
    styleUrls: ['navigation-menu.component.css']
})
export class NavigationMenuComponent implements NavigationMenuContainerInterface, OnInit, OnDestroy {
    private routeSubscription: Subscription;
    private mSelected: any;

    public children: NavigationMenuElementComponent[];

    public set selected(value: any) {
        this.mSelected = value;
        if (this.selectedChanged != null) {
            this.selectedChanged.emit(this.mSelected);
        }
    }

    @Input()
    public get selected(): any {
        return this.mSelected;
    }

    @Output()
    public selectedChanged: EventEmitter<any>;

    constructor(private router: Router) {
        this.children = [];
        this.selectedChanged = new EventEmitter();
    }

    ngOnInit() {
        this.routeSubscription = this.router.events
            .filter((event) => event instanceof NavigationEnd)
            .subscribe(() => {
                this.checkSelectionLink();
            });
    }

    ngOnDestroy() {
        if (this.routeSubscription) {
            this.routeSubscription.unsubscribe();
        }
    }

    public addElement(element: NavigationMenuElementComponent) {
        element.onElementSelection = this.selectedChanged;
        this.children.push(element);
    }

    public changeActiveChild(navigationMenuElement: NavigationMenuElementComponent) {
        this.children.forEach((element: NavigationMenuElementComponent) => {
            if (element !== navigationMenuElement) {
                element.active = false;
            }
        });
    }

    public onElementSelection(event: any) {
        this.selected = event;
    }

    public checkSelectionLink() {
        this.children.forEach((child: NavigationMenuElementComponent) => {
            child.checkSelectionLink();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/components/generic/navigation-menu/navigation-menu.component.ts